import { createApi } from "@reduxjs/toolkit/query/react";
import { USER } from "src/@types/USER";
import { btBaseQuery } from "src/Common/common";

// Define a service using a base URL and expected endpoints
export const usersApi = createApi({
	reducerPath: "usersApi",
	baseQuery: btBaseQuery,
	tagTypes: ["User", "Users"],

	endpoints: (builder) => ({
		getUsers: builder.query<USER[], void>({
			query: () => `user`,
			providesTags: ["Users"],
		}),
		getUser: builder.query<USER, number>({
			query: (id) => `user/user/${id}`,
			providesTags: ["User"],
		}),
		signIn: builder.mutation({
			query: (user) => ({
				url: `/user/signin/`,
				method: "POST",
				body: user,
			}),
		}),
		insertUser: builder.mutation({
			query: (user) => ({
				url: `/user/`,
				method: "POST",
				body: user,
			}),
		}),
		updateUser: builder.mutation({
			query: (user) => ({
				url: `/user/`,
				method: "PUT",
				body: user,
			}),
			invalidatesTags: ["User"],
		}),
		deleteUser: builder.mutation({
			query: (user: USER) => ({
				url: `/user/${user.USERID}`,
				method: "DELETE",
				body: user,
			}),
			invalidatesTags: ["Users"],
		}),
		appUser: builder.mutation({
			query: (user) => ({
				url: `/user/app/`,
				method: "POST",
				body: user,
			}),
			invalidatesTags: ["Users"],
		}),
	}),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
	useGetUsersQuery,
	useGetUserQuery,
	useSignInMutation,
	useInsertUserMutation,
	useUpdateUserMutation,
	useDeleteUserMutation,
	useAppUserMutation,
} = usersApi;
